/**
 * i18n configuration
 * Contains language settings and available languages
 */

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'sr', name: 'Srpski', flag: '🇷🇸' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' }
];

export const defaultLanguage = 'en';

export const fallbackLanguage = 'en';
